import { Link } from "react-router-dom";

const FEATURES = [
  {
    icon: "🤖",
    tag: "AI",
    tagColor: "#6366F1",
    title: "AI Spesialis Arduino",
    desc: "Terlatih khusus untuk Arduino, ESP32, NodeMCU, dan sistem embedded. Bukan AI umum.",
  },
  {
    icon: "⚡",
    tag: "Produktif",
    tagColor: "#0EA5E9",
    title: "Kode Siap Pakai",
    desc: "Dapatkan kode lengkap beserta penjelasan mendalam dalam satu percakapan.",
  },
  {
    icon: "📋",
    tag: "Template",
    tagColor: "#10B981",
    title: "17+ Template",
    desc: "Dari level pemula hingga lanjutan. Filter per platform, langsung copy & upload.",
  },
  {
    icon: "🎓",
    tag: "Riset",
    tagColor: "#F59E0B",
    title: "Berbasis Riset STEAM",
    desc: "Dikembangkan tim peneliti Universitas Negeri Malang untuk pendidikan nyata.",
  },
  {
    icon: "🌐",
    tag: "Platform",
    tagColor: "#EC4899",
    title: "Multi-Platform",
    desc: "Arduino Uno, Mega, ESP32, ESP8266, NodeMCU, dan banyak lagi.",
  },
  {
    icon: "🔒",
    tag: "Gratis",
    tagColor: "#8B5CF6",
    title: "100% Gratis",
    desc: "Daftar dan langsung gunakan semua fitur tanpa biaya, tanpa batas percakapan.",
  },
];

function Features() {
  return (
    <section className="lp-features" id="features">
      <div className="lp-features-inner">
        {/* Header */}
        <div className="lp-feat-header">
          <span className="lp-feat-pill">⚙️ Fitur Unggulan</span>
          <h2 className="lp-feat-title">
            Semua yang Kamu Butuhkan<br />
            untuk Kuasai Arduino
          </h2>
          <p className="lp-feat-desc">
            Dari kode, template, hingga penjelasan — semuanya ada di satu tempat.
          </p>
        </div>

        {/* Grid */}
        <div className="lp-feat-grid">
          {FEATURES.map((f, i) => (
            <div className="lp-feat-card" key={i}>
              <div className="lp-feat-icon">{f.icon}</div>
              <span className="lp-feat-tag" style={{ color: f.tagColor, background: f.tagColor + "18" }}>
                {f.tag}
              </span>
              <h3 className="lp-feat-name">{f.title}</h3>
              <p className="lp-feat-text">{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="lp-feat-cta">
          <Link to="/register" className="lp-btn-primary">
            Coba Sekarang — Gratis
          </Link>
          <Link to="/login" className="lp-btn-ghost-dark">
            Sudah punya akun? Masuk →
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Features;